<template>
  <b-container class="header" id="header">
    <b-row>
      <b-col class="col-puuinfo py-5">
        <router-link to="/">
          <img src="../assets/epuu-logo.png" alt="ePuu" class="logo-epuu">
        </router-link>
        <router-link to="/">
          <img src="../assets/puuinfo-logo-iso.png" class="logo" alt="Puuinfo">
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'Header',
  data () {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo-epuu{
    width: 200px;
    height: auto;
    margin-bottom: 2em;
  }
  .logo {
    width: 120px;
    height: auto;
  }
  .epuu-icon{
    width: 44px;
    height: auto;
    margin-right: 1em;
  }

  .col-puuinfo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
  }

  @media print {
    .header {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue